import React, { FC, useState } from 'react';

import Image from 'next/image';

import { Modal } from 'antd';

import PresentationPreview from '@/assets/video-preview/video_001.jpg';
import RegistrationPreview from '@/assets/video-preview/video_002.jpg';
import AddFishPreview from '@/assets/video-preview/video_003.jpg';
import CardFillPreview from '@/assets/video-preview/video_004.jpg';
import FindWarehousePreview from '@/assets/video-preview/video_005.jpg';
import SubscribePreview from '@/assets/video-preview/video_006.jpg';
import DigitalWarehousePreview from '@/assets/video-preview/video_007.jpg';
import { useTranslate } from '@/hooks/use-translate';

import { en } from '../en';

import styles from './TrainingVideosSection.module.scss';

export const TrainingVideosSection: FC = () => {
	const t = useTranslate(en);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [activeVideo, setActiveVideo] = useState<number>();

	const handleVideoClick = (index: number) => {
		setActiveVideo(index);
		setIsModalOpen(true);
	};

	const arrVid = [
		{
			title: t('Презентация платформы Fishplace'),
			frame: (
				<iframe
					width="100%"
					height="100%"
					style={{ borderRadius: '16px' }}
					src="https://rutube.ru/play/embed/0171231f46c55908adbba1759ab72e1a/"
					frameBorder="0"
					allow="clipboard-write; autoplay"
					// @ts-ignore
					webkitAllowFullScreen
					mozallowfullscreen
					allowFullScreen
				/>
			),
			preview: PresentationPreview,
		},
		{
			title: t('Регистрация холодильного склада'),
			frame: (
				<iframe
					width="100%"
					height="100%"
					style={{ borderRadius: '16px' }}
					src="https://rutube.ru/play/embed/cd2d002346ccafab0fe635f8d6f81b3c/?p=dC8fVAuwCyWO95oAJs9cRA"
					frameBorder="0"
					allow="clipboard-write; autoplay"
					//@ts-ignore
					webkitAllowFullScreen
					mozallowfullscreen
					allowFullScreen
				/>
			),
			preview: RegistrationPreview,
		},
		{
			title: t('Добавление рыбопродукции на платформу'),
			frame: (
				<iframe
					width="100%"
					height="100%"
					style={{ borderRadius: '16px' }}
					src="https://rutube.ru/play/embed/20017d4e88f2442fef6f9f5bbf80c00f/"
					frameBorder="0"
					allow="clipboard-write; autoplay"
					//@ts-ignore
					webkitAllowFullScreen
					mozallowfullscreen
					allowFullScreen
				/>
			),
			preview: AddFishPreview,
		},
		{
			title: t('Оформление карточки рыбопродукции'),
			frame: (
				<iframe
					width="100%"
					height="100%"
					style={{ borderRadius: '16px' }}
					src="https://rutube.ru/play/embed/45360d354d073f40e1520d16904d8c5a/"
					frameBorder="0"
					allow="clipboard-write; autoplay"
					//@ts-ignore
					webkitAllowFullScreen
					mozallowfullscreen
					allowFullScreen
				/>
			),
			preview: CardFillPreview,
		},
		{
			title: t('Поиск склада и заявка на хранение'),
			frame: (
				<iframe
					width="100%"
					height="100%"
					style={{ borderRadius: '16px' }}
					src="https://rutube.ru/play/embed/71610ed8a9333e6859a64959dedec25e/"
					frameBorder="0"
					allow="clipboard-write; autoplay"
					//@ts-ignore
					webkitAllowFullScreen
					mozallowfullscreen
					allowFullScreen
				/>
			),
			preview: FindWarehousePreview,
		},
		{
			title: t('Подписка на рыбопродукцию'),
			frame: (
				<iframe
					width="100%"
					height="100%"
					style={{ borderRadius: '16px' }}
					src="https://rutube.ru/play/embed/fd1666029793fa94f6cd5f6d0b726845/"
					frameBorder="0"
					allow="clipboard-write; autoplay"
					//@ts-ignore
					webkitAllowFullScreen
					mozallowfullscreen
					allowFullScreen
				/>
			),
			preview: SubscribePreview,
		},
		{
			title: t('Цифровой офис на платформе fishplace.ru'),
			frame: (
				<iframe
					width="100%"
					height="100%"
					style={{ borderRadius: '16px' }}
					src="https://rutube.ru/play/embed/7b364eae2e453a3c752bb454582d3f59/?p=EH_YTmUD1kNNyLjNNZyw_g"
					frameBorder="0"
					allow="clipboard-write; autoplay"
					//@ts-ignore
					webkitAllowFullScreen
					mozallowfullscreen
					allowFullScreen
				/>
			),
			preview: DigitalWarehousePreview,
		},
	];

	return (
		<section className={styles.trainingVideosSection}>
			<div className={styles.content}>
				<div className={styles.trainingHeader}>
					<h2 className={styles.subtitle}>{t('Обучающее видео')}</h2>
					<a
						href="https://rutube.ru/channel/40937493/"
						target="_blank"
						className={styles.link}
						rel="noreferrer"
					>
						{/* <Image width={34} height={24} src={YoutubeIcon} alt="Youtube" /> */}
						{t('Наш RuTube канал →')}
					</a>
				</div>
				<div className={styles.videos}>
					{arrVid.map((vid, index) => (
						<div
							key={vid.title}
							className={styles.videoItem}
							onClick={() => handleVideoClick(index)}
						>
							<Image
								src={vid.preview}
								alt="image"
								className={styles.image}
								//@ts-ignore
								width="auto"
								//@ts-ignore
								height="auto"
							/>
							<span className={styles.videosName}>{vid.title}</span>
						</div>
					))}
				</div>
				<Modal
					title={arrVid[activeVideo]?.title}
					open={isModalOpen}
					onCancel={() => setIsModalOpen(false)}
					width={1080}
					footer={false}
				>
					<div className={styles.modalVideo}>{arrVid[activeVideo]?.frame}</div>
				</Modal>
			</div>
		</section>
	);
};
